import React from 'react'
import { Policies } from '../PrivacyPolicy'
import styles from '../privacyPolicy.module.scss'

export const COOKIES = {
  intro: (
    <p>
      <strong>Please read this policy carefully.</strong>
    </p>
  ),
  sections: [
    {
      title: 'About Us',
      content: props => (
        <>
          <p>
            ITF Licensing (UK) Limited trading as the International Tennis Federation (ITF) is
            committed to protecting and respecting your privacy in accordance with the applicable
            data protection laws which impose certain obligations on us. This policy provides you
            with the necessary information regarding our use of cookies.
          </p>
          <p>
            We may need to change this Cookies Policy in the future. If we make any substantial
            changes that materially affect you, we will inform you before they take effect.
          </p>
          <p>
            If you require any further information, or wish to contact us about our use of cookies,
            our contact details are:
          </p>
          <table className={styles.privacyPolicyTable}>
            <tbody>
              <tr>
                <td>
                  <p>Address</p>
                </td>
                <td>
                  <p>Bank Lane, Roehampton, London UK, SW15 5XZ</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>Telephone Number</p>
                </td>
                <td>
                  <p>+44 20 8878 6464</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>Data Protection Officer&rsquo;s Email</p>
                </td>
                <td>
                  <p>
                    <a href='mailto:dataprotectionofficer@itftennis.com'>
                      dataprotectionofficer@itftennis.com
                    </a>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </>
      ),
    },
    {
      title: 'Our use of cookies',
      content: props => (
        <>
          <p>
            In common with many other website operators, we use cookies on our website. We use them
            to enrich your experience of using the website by allowing us to tailor what you see to
            what we have learned about your preferences during your visits to the site. Our cookies
            are also used to enable us to develop our website to reflect our customers interests by
            noting who has seen which pages, how frequently particular pages are visited and
            determining the most popular areas of our website. We and carefully selected third
            parties also use cookies to show you more relevant advertising online.
          </p>
          <p>
            We also use cookies to ensure that our website remains secure and that requests for
            pages on the website are coming from real humans are and not harmful, automated 'bots'.
            These cookies do not collect or store any personal data or any information that could
            uniquely identify you as an individual.
          </p>
          <p>
            We may incorporate social plugins for various online social networks (e.g. Facebook,
            Twitter and YouTube) into some pages on our website. These services may use their own
            cookies (third-party cookies) to identify you and track information about your visit to
            our website.
          </p>
        </>
      ),
    },
    {
      title: 'What is a cookie policy?',
      content: props => (
        <>
          <p>
            Information may be sent to your computer in the form of an Internet "cookie" to allow
            our servers to monitor your requirements. The cookie is stored on your computer. Our
            server may request that your computer return a cookie to it.
          </p>
          <p>
            These return cookies do not contain any information supplied by you or any personally
            identifiable information about you. However, we use cookies to keep track of any
            purchase you make of ITF products and services.
          </p>
          <p>
            Such measures are necessary to allow the ITF and its subsidiaries to measure the
            usability of the systems, which will help to continually improve user experience of our
            websites. Your browser software should however enable you to block cookies if you wish
            to. For more information about cookies, please visit{' '}
            <a href='http://www.allaboutcookies.org/' rel='noopener noreferrer' target='_blank'>
              http://www.allaboutcookies.org/
            </a>
            .
          </p>
          <p>In general, we use the following types of cookie:</p>
        </>
      ),
    },
    {
      title: 'Strictly necessary cookies',
      content: props => (
        <>
          <p>
            These cookies are essential in order to enable you to move around the website and use
            its features, such as accessing secure areas of the website. Without these cookies
            services you have asked for like online purchases and e-billing, cannot be provided.
          </p>
        </>
      ),
    },
    {
      title: 'Performance cookies',
      content: props => (
        <>
          {' '}
          <p>
            These cookies collect information about how visitors use a website, for instance which
            pages visitors go to most often, and if they get error messages from web pages. These
            cookies don't collect information that identifies a visitor. All information these
            cookies collect is aggregated and therefore anonymous. It is only used to improve how a
            website works.
          </p>
        </>
      ),
    },
    {
      title: 'Functionality cookies',
      content: props => (
        <>
          <p>
            These cookies allow the website to remember choices you make (such as your user name,
            language or the region you are in) and provide enhanced, more personal features. For
            instance, a website may be able to provide you with local weather reports by storing in
            a cookie the region in which you are currently located.
          </p>
          <p>
            These cookies can also be used to remember changes you have made to text size, fonts and
            other parts of web pages that you can customise. They may also be used to provide
            services you have asked for such as watching a video or downloading a form. The
            information these cookies collect may be anonymised and they cannot track your browsing
            activity on other websites.
          </p>
        </>
      ),
    },
    {
      title: 'Google Analytics',
      content: props => (
        <>
          <p>
            The ITF uses Google Analytics, a web analytics service provided by Google. Google
            Analytics collects first party cookies, which are text files placed on your computer to
            collect standard internet log information and visitor behaviour. This information is
            sent to Google and is used to evaluate how our website is being used. This enables us to
            compile statistical reports. A full list of cookies used by Google Analytics and
            explanations on how these work are available on the Google code website.
          </p>
          <p>
            The ITF does not collect (nor allow any third party to collect) personally identifiable
            information of visitors to our site. We will not associate any data gathered with any
            personally identifying information. We will not link or seek to link an IP address with
            the identity of a computer user. In short, Google Analytics doesn't identify who you
            are, but it does track your movements on our websites.
          </p>
        </>
      ),
    },
    {
      title: 'How to disable cookies',
      content: props => (
        <>
          <p>
            You can stop cookies being downloaded on to your computer by selecting the appropriate
            settings on your browser. However please note that if you do this you may not be able to
            use the full functionality of this website. There is more information about cookies,
            including how to delete them on the website{' '}
            <a href='http://www.allaboutcookies.org/' rel='noopener noreferrer' target='_blank'>
              http://www.allaboutcookies.org/
            </a>
            . You may also opt out of being tracked by Google Analytics by visiting{' '}
            <a
              href='https://tools.google.com/dlpage/gaoptout'
              rel='noopener noreferrer'
              target='_blank'
            >
              tools.google.com/dlpage/gaoptout
            </a>
            .
          </p>
        </>
      ),
    },
  ],
}

export const UNDER_18 = {
  intro: (
    <>
      {' '}
      <p>
        <strong>
          If you want an ITF WORLD TENNIS NUMBER, and you are not 18 years old yet, you should read
          this. It tells you what we do with your information.
        </strong>
      </p>
      <p>
        <strong>
          Speak to your parent or guardian about it as well.They can help you to decide what
          features of the ITF WORLD TENNIS NUMBER you would like to access.
        </strong>
      </p>
    </>
  ),
  sections: [
    {
      title: 'The International Tennis Federation',
      content: props => (
        <>
          <p>
            We look after tennis all over the world. We make sure the rules are followed and we try
            to make tennis the best sport it can be. We have to comply with laws about how we
            collect and use your information (which we call “
            <strong>
              <u>DATA</u>
            </strong>
            ”). We collect your DATA so we can give you an ITF World Tennis Number (“
            <strong>ITF WORLD TENNIS NUMBER</strong>”).
          </p>
        </>
      ),
    },
    {
      title: 'Why is this important to you',
      content: props => (
        <>
          <p>
            <em>Don’t ignore the boring stuff…</em>
          </p>
          <p>
            Your right to privacy is really important.Because you are not yet 18 years old, we need
            to handle your DATA very carefully and keep it safe so other people cannot use it to do
            things that will cause you any harm or distress  (now or in the future).
          </p>

          <p>
            We know there is a lot of information here, but please make sure you read it all.It will
            tell you:{' '}
          </p>
          <ol>
            <li>WHAT we do with your DATA; </li>
            <li>WHY we need it, and most importantly; </li>
            <li>HOW we protect it when we use it.</li>
          </ol>
          <p>
            Sometimes we start to do different things with your DATA.If we do, we will update this
            information and let you know.If you have any questions about how we use your DATA please
            get in touch:{' '}
          </p>
          <p>
            By email:{' '}
            <a href='mailto:dataprotectionofficer@iftennis.com'>
              dataprotectionofficer@iftennis.com
            </a>
          </p>
          <p>By telephone: +44 20 8878 6464.</p>
        </>
      ),
    },
    {
      title: 'Where do we get your DATA?',
      content: props => (
        <>
          <p>
            <em>From you, and your people…</em>
          </p>
          <p>We get your DATA when: </p>
          <ol>
            <li className={styles.marginBottom}>
              <p className={styles.marginBottom}>You give it to us</p>
              <ul>
                <li>
                  because you would like an ITF WORLD TENNIS NUMBER to store your results and track
                  how you are improving in your tennis; or
                </li>
                <li>
                  because you are updating your ITF WORLD TENNIS NUMBER profile or telling us if you
                  won or lost a recent match.
                </li>
              </ul>
            </li>
            <li>
              <p className={styles.marginBottom}>
                Your National Tennis Association (“<strong>NTA</strong>”), for example this would be
                the Lawn Tennis Association (LTA) if you live in the UK or the USTA in America,
                gives it to us{' '}
              </p>
              <ul>
                <li>
                  because they already have your information and would like you to have an ITF WORLD
                  TENNIS NUMBER to track your tennis development.But they will tell you that they
                  are going to give us your DATA – which they might do in a notice similar to this
                  or by asking you if you would like one.
                </li>
              </ul>
            </li>
          </ol>
          <p>Sometimes we also get your DATA: </p>
          <ul>
            <li> from chair umpires or officials that watch your match; </li>
            <li> from players you play tennis against; </li>
            <li>
              when we ask you to complete optional surveys that we use for research and to make your
              ITF WORLD TENNIS NUMBER experience the best it can be.
            </li>
          </ul>
        </>
      ),
    },
    {
      title: 'What DATA do we get?',
      content: props => (
        <>
          <p>
            <em>Only what we need to give you an ITF WORLD TENNIS NUMBER…</em>
          </p>
          <table className={styles.privacyPolicyTable}>
            <tbody>
              <tr>
                <td>
                  <p>you</p>
                </td>
                <td>
                  <ul>
                    <li>full name</li>
                    <li> email address</li>
                    <li> gender</li>
                    <li>date of birth</li>
                    <li> nationality</li>
                    <li> NTA you are linked to</li>
                    <li>country where you live</li>
                    <li> full name and email address of your parent/guardian</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <p>your technology</p>
                </td>
                <td>
                  <ul>
                    <li>
                      {' '}
                      information about the type of computer, phone or tablet you use to log-in such
                      as the operating system and IP address
                    </li>
                    <li> security information (passwords, secret questions)</li>
                    <li>
                      {' '}
                      cookies, which store information about how you’ve used the platform (
                      <button
                        className={styles.link}
                        onClick={() => {
                          props.setSelectedTab(Policies.COOKIE_POLICY)
                          window.scrollTo({ top: 0 })
                        }}
                      >
                        Cookie Policy
                      </button>
                      )
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <p>your tennis</p>
                </td>
                <td>
                  <ul>
                    <li> your ITF WORLD TENNIS NUMBER</li>
                    <li>match results (local, national and international)</li>
                    <li>
                      {' '}
                      your tennis story (e.g.when you started playing tennis, your playing hand,
                      your favourite player)
                    </li>
                    <li>head-to-head results with other players</li>
                    <li>
                      {' '}
                      any other information you provide to us for your ITF WORLD TENNIS NUMBER
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <p>your messages</p>
                </td>
                <td>
                  <ul>
                    <li>
                      {' '}
                      messages you (or your parents) send to us about your ITF WORLD TENNIS NUMBER
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </>
      ),
    },
    {
      title: 'Can we use your DATA?',
      content: props => (
        <>
          <p>
            <em>Yes, and this is why... </em>
          </p>
          <p>We use your data to: </p>
          <ul>
            <li>Provide you with an ITF WORLD TENNIS NUMBER when you sign up to the service</li>
            <li>Calculate your ITF WORLD TENNIS NUMBER based on matches you play</li>
            <li>
              Research how tennis is played to try to improve the game and encourage people to play
              more
            </li>
            <li>Make sure nobody breaks any laws or rules around the ITF WORLD TENNIS NUMBER</li>
          </ul>
          <p>
            We make sure we have a legal reason to do so, in line with laws such as the General Data
            Protection Regulation and UK Data Protection Act 2018.
          </p>
          <p>
            Information about how we calculate your ITF WORLD TENNIS NUMBER can be found{' '}
            <a
              href='https://worldtennisnumber.com/eng/faq#1-3'
              rel='noopener noreferrer'
              target='_blank'
            >
              here
            </a>
            .
          </p>
          <p>
            We will also contact your parent/guardian when you register for your ITF WORLD TENNIS
            NUMBER to make sure you have their permission.
          </p>
          <p>
            Remember – you or your parent/guardian can always ask us why we use your DATA by
            contacting our Data Protection Team.We will consider any request to stop using your data
            but there may be circumstances where we have to keep a small amount of data, like match
            results.
          </p>
        </>
      ),
    },
    {
      title: 'Marketing',
      content: props => (
        <>
          <p>
            <em>We won’t send you stuff…</em>
          </p>
          <p>
            We won’t send you any emails that are not directly connected to ITF WORLD TENNIS NUMBER,
            so you won’t get any spam or junk mail from us or information about our other products
            or services or special offers.We will, however, send you emails about the ITF WORLD
            TENNIS NUMBER unless you ask us not to.
          </p>
        </>
      ),
    },
    {
      title: 'Who else gets your DATA',
      content: props => (
        <>
          <p>
            <em>It’s a bit complicated…</em>
          </p>
          <p>
            We need to share your DATA with other organisations to make sure you get all the
            benefits of having an ITF WORLD TENNIS NUMBER.The DATA on the ITF WORLD TENNIS NUMBER
            platform is kept safe by the company that runs the ITF WORLD TENNIS NUMBER platform for
            us.That company is called ClubSpark.We make sure that ClubSpark keeps your DATA safe and
            secure, and they only do what we tell them to do.
          </p>
          <p>We also share your DATA with: </p>
          <ul>
            <li>your parents/guardians, and any person you ask us to share your DATA with; </li>
            <li>
              your NTA, because they want to keep track of how well you are doing and understand how
              many people are playing tennis in their country;{' '}
            </li>
            <li>the NTAs of players you compete against; </li>
            <li>our platform partner, ClubSpark; and</li>
            <li>
              Other NTAs who wish to track your development, if your parent/guardian provide us with
              permission to do so.
            </li>
          </ul>
          <p>Your NTA will also handle your DATA.You can ask your NTA for further information.</p>
          <p>
            We may need to share your DATA with the police or other official bodies if the law says
            we have to.
          </p>
        </>
      ),
    },
    {
      title: 'Sending your DATA overseas (away from Europe)',
      content: props => (
        <>
          <p>
            <em>It depends where you live and where you travel to…</em>
          </p>
          <p>
            If your NTA is based outside Europe we have to send your personal data outside Europe.If
            you play a tennis match outside Europe we may send your personal data to the NTA of the
            country where you play but only if it is necessary for your ITF WORLD TENNIS NUMBER or
            the NTA needs it for their records.We only send your DATA in a safe and secure way.You
            can contact us for more information about this.
          </p>
        </>
      ),
    },
    {
      title: 'Can we keep your DATA?',
      content: props => (
        <>
          <p>
            <em>Yes. But not forever…</em>
          </p>
          <p>
            We will keep your contact details and your ITF WORLD TENNIS NUMBER profile information
            for one year after you ask us to delete your ITF WORLD TENNIS NUMBER account.
          </p>
          <p>
            We will keep your match results while the ITF WORLD TENNIS NUMBER is still used to rate
            tennis players..Your complete match  data  record is kept for four years after you ask
            us to delete your account  to make sure the ITF WORLD TENNIS NUMBER keeps working for
            other players.
          </p>
          <p>If you send us any emails, we will keep these for ten years.</p>
          <p>We may keep your DATA for longer if the law says we should.</p>
        </>
      ),
    },
    {
      title: 'Your legal rights',
      content: props => (
        <>
          <p>
            <em>Don’t worry, you’re in control…</em>
          </p>
          <p>You can ask for specific things to be done with your DATA.</p>
          <ul>
            <li>You can see your DATA and ask us to correct any DATA that is not right; </li>
            <li>You can ask us to send your DATA to another person or organisation; </li>
            <li>You can ask that we delete your DATA (or some of it); </li>
            <li>You can ask us to restrict/limit our use of your DATA; and</li>
            <li>You can say no to us using your DATA.</li>
          </ul>
          <p>
            Sometimes the law says that we can say no to these requests, but we will explain this to
            you if you ask.
          </p>
          <p>
            Please ask for your parents/guardians’ permission if you want to contact us about your
            rights.
          </p>
        </>
      ),
    },
    {
      title: 'How to complain',
      content: props => (
        <>
          <p>
            <em>If you are unhappy…</em>
          </p>
          <p>
            You can complain to our Data Protection Team if you are unhappy about anything in this
            notice.You can also complain to the United Kingdom’s data authority, the Information
            Commissioner via{' '}
            <a href='http://www.ico.org.uk' target='_blank' rel='noopener noreferrer'>
              www.ico.org.uk
            </a>
            .
          </p>
        </>
      ),
    },
    {
      title: 'Did this make sense to you?',
      content: props => (
        <>
          <p>
            We also have this notice in French and Spanish.We can provide it in large print, Braille
            and audio if you need.
          </p>
        </>
      ),
    },
  ],
}

export const OVER_18 = {
  intro: (
    <>
      <p>
        <em>
          Note: This Privacy Notice only applies to individuals who have used the ITF World Tennis
          Number services. If you also have an IPIN account or you deal with the ITF in any other
          way, please refer to our Privacy Notice library for information on how we process your
          personal data for other reasons.
        </em>
      </p>
      <p>
        <strong>Please read this notice carefully. </strong>
      </p>
      <p>Last updated: 29th April 2024</p>
    </>
  ),
  sections: [
    {
      title: 'About Us',
      content: props => (
        <>
          <p>
            ITF Licensing (UK) Limited trading as the International Tennis Federation (ITF) is a
            data controller of any personal data it collects and holds about you. The ITF is
            referred to as &ldquo;we&rdquo;, &ldquo;us&rdquo; and &ldquo;our&rdquo; in this privacy
            notice. We are a company registered in England and Wales under company number 02584446.
            We are registered on the Information Commissioner's Office Register; registration number
            Z5603782.
          </p>
          <p>
            We are committed to protecting and respecting your privacy in accordance with the
            applicable data protection laws which impose certain obligations on us as a data
            controller. This notice provides you with the necessary information regarding your
            rights and our obligations, and explains how, why and when we process your personal
            data.
          </p>
          <p>
            We will endeavour to inform you of any substantial changes to our processing of your
            personal data. We may also provide you with other specific privacy notices if we process
            different types of data for you.
          </p>
          <p>
            If you require any further information, or wish to contact us about how we collect and
            store your data, our contact details are:
          </p>
          <table className={styles.privacyPolicyTable}>
            <tbody>
              <tr>
                <td>
                  <p>Address</p>
                </td>
                <td>
                  <p>Bank Lane, Roehampton, London UK, SW15 5XZ</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>Telephone Number</p>
                </td>
                <td>
                  <p>+44 20 8878 6464</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>Data Protection Officer&rsquo;s Email</p>
                </td>
                <td>
                  <p>
                    <a href='mailto:dataprotectionofficer@itftennis.com'>
                      dataprotectionofficer@itftennis.com
                    </a>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            To comply with the General Data Protection Regulation (2016/679) we have appointed a
            European representative. If you wish to contact them, their details are as follows:
          </p>
          <p className={styles.address}>
            Bird & Bird GDPR Representative Services SRL
            <br />
            Avenue Louise 235
            <br />
            1050 Bruxelles Belgium
            <br />
            <a href='mailto:EUrepresentative.ITF@twobirds.com'>EUrepresentative.ITF@twobirds.com</a>
            <br />
            Key Contact: Vincent Rezzouk-Hammachi
          </p>
        </>
      ),
    },
    {
      title: 'Who this privacy notice applies to',
      content: props => (
        <>
          <p>
            This privacy notice explains how we will use the personal data of anyone who registers
            for and/or is provided an ITF World Tennis Number (&ldquo;WTN&rdquo;), or who engages
            with the WTN website or services (including national tennis association
            (&ldquo;NTA&rdquo;) staff with registered user log-ins). Each such person is referred to
            as &ldquo;you&rdquo; and &ldquo;your&rdquo; in this privacy notice.
          </p>
        </>
      ),
    },
    {
      title: 'How we obtain your personal data',
      content: props => (
        <>
          <p>We collect and process your data when:</p>
          <ul>
            <li>
              you register for WTN (whether online, or through your national tennis association
              (“NTA”), Regional Tennis Association (RTA) or your participation in ITF competitions);
            </li>
            <li>
              your NTA or RTA provides us with information about you to create a WTN for you, or
              when requested that we create an NTA employee user profile for you; and
            </li>
            <li>
              you access and/or engage with the WTN services or helpdesk, for example when you
              update your profile, input your match results, upload your photograph and contact us
              with enquiries.
            </li>
          </ul>
          <p>We may also obtain data about you:</p>
          <ul>
            <li>from your NTA or RTA;</li>
            <li>from other ITF systems such as IPIN;</li>
            <li>from organisations such as the WTA, ATP or Grand Slam Board;</li>
            <li>from officials that officiate your tennis matches and from your opponents;</li>
            <li>
              from other tennis organisations and/or regulatory organisations, who write to us in
              relation to you or who we contact in relation to investigations or other enquiries,
              for example in relation to matters of safeguarding, or corrupt conduct;
            </li>
            <li>
              when we ask you to complete optional surveys that we use for research purposes and to
              provide you with a more relevant player and user experience; and
            </li>
            <li>
              when you interact with the ITF via our digital platforms which may include the use of
              cookies (subject to our{' '}
              <button
                className={styles.link}
                onClick={() => {
                  props.setSelectedTab(Policies.COOKIE_POLICY)
                  window.scrollTo({ top: 0 })
                }}
              >
                Cookie Policy
              </button>
              ); and
            </li>
            <li>
              when you engage with us in relation to marketing including opting-in to our
              communications and marketing material, enter competitions and engage with our
              promotional campaigns.
            </li>
          </ul>
        </>
      ),
    },
    {
      title: 'The types of personal data we process',
      content: props => (
        <>
          <p>
            We may process a wide variety of personal data about you, including personal data about:
          </p>
          <table className={styles.privacyPolicyTable}>
            <tbody>
              <tr>
                <td>
                  <p>you as an individual</p>
                </td>
                <td>
                  <ul>
                    <li> full name and title;</li>
                    <li> email address;</li>
                    <li> gender;</li>
                    <li> date of birth;</li>
                    <li> nationality;</li>
                    <li> country of residence;</li>
                    <li> photograph;</li>
                    <li> language spoken;</li>
                    <li> your unique user ID (ITF Tennis ID).</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <p>other information identifying you</p>
                </td>
                <td>
                  <ul>
                    <li>
                      {' '}
                      device identifiers including IP address, and other information about your
                      device such as device and application identifying numbers, location, browser
                      type, hardware model, service provider/mobile carrier, operating system and
                      system configuration information;
                    </li>
                    <li> password;</li>
                    <li>
                      {' '}
                      user account secret question and answer which may relate to you or people you
                      know
                    </li>
                    <li>
                      {' '}
                      cookies and other tracking technologies (like web beacons and pixels) (subject
                      to our{' '}
                      <button
                        className={styles.link}
                        onClick={() => {
                          props.setSelectedTab(Policies.COOKIE_POLICY)
                          window.scrollTo({ top: 0 })
                        }}
                      >
                        Cookie Policy
                      </button>
                      ).
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <p>your location</p>
                </td>
                <td>
                  <ul>
                    <li>
                      {' '}
                      if you elect to enable the location services in your WTN profile to arrange
                      tennis matches with other players
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <p>your playing information</p>
                </td>
                <td>
                  <ul>
                    <li> your WTN rating</li>
                    <li>
                      {' '}
                      activity and results in tennis matches (local, national and international);
                    </li>
                    <li>
                      {' '}
                      tennis biography details such as when you started playing tennis, playing
                      hand/doubles hand, and favourite player;
                    </li>
                    <li> head-to-head results with other players;</li>
                    <li>
                      {' '}
                      performance data from tennis matches played by you and recorded by our
                      third-party data suppliers for sporting reasons;
                    </li>
                    <li> any other information you provide to us for your WTN profile.</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <p>your preferences</p>
                </td>
                <td>
                  <ul>
                    <li>
                      {' '}
                      whether you wish to receive marketing from us and which types of marketing
                      material you would like to receive.
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <p>your profile and user experience</p>
                </td>
                <td>
                  <ul>
                    <li>
                      {' '}
                      details of our services with you, including how you access and use those
                      services, for example via smart phone application, web browser etc;
                    </li>
                    <li>
                      {' '}
                      log and usage data related to how you use the WTN website, such as access
                      times, device and browser information, and actions taken during use of the
                      website while logged in;
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <p>your correspondence</p>
                </td>
                <td>
                  <ul>
                    <li>
                      {' '}
                      information contained in any correspondence, or communications received or
                      sent by you in relation to your WTN.
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </>
      ),
    },
    {
      title: 'How we will use your personal data and the legal basis for using that personal data',
      content: props => (
        <>
          <table className={styles.privacyPolicyTable}>
            <tbody>
              <tr>
                <td colSpan={2} className={styles.bg}>
                  <p>
                    <strong>
                      Performance of our contract with you or a contract with a third-party that is
                      in your interest
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>
                      Fulfil the contract of service that you enter into with us or that we enter
                      with your NTA in your interest to provide you with a WTN
                    </strong>
                  </p>
                </td>
                <td>
                  <p>We may use your personal data to:</p>
                  <ul>
                    <li>
                      {' '}
                      verify your identity via your ITF Tennis ID single sign-on user account
                      details;
                    </li>
                    <li>
                      {' '}
                      set up your ITF Tennis ID and WTN accounts and authenticate your registration
                      when you register with us or when your NTA provides your personal data to us
                      for that purpose;
                    </li>
                    <li> provide you with access to the WTN website and your WTN rating;</li>
                    <li> provide accurate information to your NTA about your WTN;</li>
                    <li>
                      {' '}
                      communicate with you regarding your account including requests you make to our
                      helpdesk and changes to terms and conditions.
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colSpan={2} className={styles.bg} width='601'>
                  <p>
                    <strong>
                      Enable our business and pursue our legitimate interests or those of a third
                      party
                    </strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>Manage and promote the WTN platform </strong>
                  </p>
                </td>
                <td>
                  <p>We will use your personal data to:</p>
                  <ul>
                    <li>
                      {' '}
                      administer the WTN platform and inform the algorithm used to calculate
                      ratings;
                    </li>
                    <li> promote tennis matches and the benefits of having an WTN;</li>
                    <li>
                      {' '}
                      provide accurate information to your NTA about the success and delivery of the
                      WTN in your nation;
                    </li>
                    <li> ask for your feedback on our services; and</li>
                    <li>
                      {' '}
                      send you product, service and new feature information about WTN (if you
                      consent to marketing).
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>Develop and promote the game of tennis </strong>
                  </p>
                </td>
                <td>
                  <p>
                    We may use your personal data to further encourage participation in the sport of
                    tennis. This could include measuring worldwide tennis activity and finding
                    insight from how players use ITF World Tennis Number. This will guide the ITF
                    and National Associations to implement development and grass roots programmes
                    that encourage bringing enjoyable and competitive tennis to more people around
                    the world.
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>Regulate and protect the integrity of the game </strong>
                  </p>
                </td>
                <td>
                  <p>We will use your personal data to:</p>
                  <ul>
                    <li> ensure your adherence to the terms and conditions for the WTN;</li>
                    <li>
                      {' '}
                      investigate and resolve any disciplinary issues or potential breaches of those
                      terms and conditions;
                    </li>
                    <li>
                      {' '}
                      uphold the highest standards of integrity for the sport of tennis and the ITF
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>Monitor and research</strong>
                  </p>
                </td>
                <td>
                  <p>We may use your personal data to:</p>
                  <ul>
                    <li>
                      {' '}
                      monitor how the game is played and the ways it is evolving to improve player
                      experience;
                    </li>
                    <li>
                      {' '}
                      undertake research to enhance the general appeal and global reach of the game;
                    </li>
                    <li> undertake research to improve technologies in tennis;</li>
                    <li>
                      {' '}
                      gather statistics about registration, membership and retention of WTN players
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>Other business interests</strong>
                  </p>
                </td>
                <td>
                  <p>We may use your personal data to:</p>
                  <ul>
                    <li>
                      {' '}
                      promote tennis and the ITF (where you engage with our promotional campaigns);
                    </li>
                    <li>
                      {' '}
                      monitor use of, improve and protect our websites and online services both
                      online and offline;
                    </li>
                    <li>
                      {' '}
                      monitor, evaluate, update, consolidate and improve the WTN, our business and
                      the services that we provide to you as well as the accuracy of our records;
                    </li>
                    <li> monitor and analyse the use of your account;</li>
                    <li>
                      {' '}
                      identify other products and services you may be interested in and telling you
                      about other products and services, including displaying personalised content
                      and advertising;
                    </li>
                    <li> obtain your feedback and respond to and rectify complaints;</li>
                    <li>
                      {' '}
                      analyse your personal data to make sure that you only receive information that
                      is relevant to you;
                    </li>
                    <li>
                      {' '}
                      develop and improve our federation and facilitate investment in, and the
                      growth of, our business and the sport;
                    </li>
                    <li> manage and mitigate the risks to you and our federation.</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colSpan={2} className={styles.bg}>
                  <p>
                    <strong>Legal Obligations</strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <strong>Comply with our legal obligations under applicable laws </strong>
                  </p>
                </td>
                <td>
                  <p>We may use your personal data to:</p>
                  <ul>
                    <li>
                      {' '}
                      monitor, prevent, investigate and/or report fraud, misrepresentation, security
                      incidents or crime, in accordance with applicable laws as well as other
                      regulatory codes;
                    </li>
                    <li>
                      {' '}
                      comply with applicable laws and protection of the ITF&rsquo;s legal rights,
                      including, but not limited to, use in connection with legal claims, and
                      compliance with our legal obligations (e.g. safeguarding, disclosure)
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td colSpan={2} className={styles.bg}>
                  <p>
                    <strong>Consent</strong>
                  </p>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <p>
                    We may seek your consent to use your personal data for specific purposes (e.g.
                    enabling location services, sharing your personal data with additional NTAs,
                    entering prize draws, etc.). You are entitled to refuse consent. However, your
                    refusal to provide consent may mean that you are unable to access the full
                    benefits of WTN.
                  </p>
                  <p>
                    We may also seek your consent to use your personal data to send you information
                    about the ITF’s products and services (including the WTN, our competitions,
                    development activity and other ITF business). Even if you refuse consent to
                    receive direct marketing material, the ITF may still contact you specifically in
                    relation to the services that you have requested (for example, confirmation of
                    changes you make to your WTN account details, or changes to the WTN services or
                    our terms and conditions).
                  </p>
                  <p>
                    From time to time we may ask for your consent to share your data with third
                    party partners or organisations that we work with. Where we ask for permission
                    from you to do this, we will explain what data will be shared, with whom, and
                    for which purposes. Your data will only be used in this way if you explicitly
                    allow it and you may opt out of any future data sharing at any time.
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            Where we have obtained your consent to processing your personal data, you are entitled
            to withdraw your consent to this at any time. You are able to withdraw consent within
            the platform or by contacting us. If you withdraw your consent, we will not continue to
            process this information for the purpose for which consent was obtained, but this will
            not impact the validity of any processing undertaken before you withdrew your consent.
          </p>
          <p>
            Where we process your personal data on the basis of legitimate interests, you can
            request a copy of the balancing test for that data processing using the contact details
            set out at the beginning of this notice.
          </p>
        </>
      ),
    },
    {
      title: 'How we use your personal data to make automated decisions',
      content: props => (
        <>
          <p>
            The algorithm that facilitates the WTN requires us to make automated decisions about you
            on the basis of your tennis performance data. This automated decision-making is pursuant
            to the contract we have with you and/or your NTA to provide you a WTN. More information
            about how the WTN is calculated can be found{' '}
            <a
              href='https://worldtennisnumber.com/eng/faq'
              rel='noopener noreferrer'
              target='_blank'
            >
              here.
            </a>
          </p>
        </>
      ),
    },
    {
      title: 'How we use your information for marketing',
      content: props => (
        <>
          <p>
            We will ask you, when you provide us with your personal data, if you are happy for us to
            contact you by email about products, competitions and services offered by us and our
            commercial partners which we think may be of interest to you. We may also ask to provide
            your information to third parties so that they can contact you about their products and
            services. If you do not agree to this, we will not use your personal data for these
            purposes. We currently only conduct email direct marketing.
          </p>
          <p>
            If at any time you would like to opt-in or opt-out to email marketing, or to otherwise
            change your preferences you can do this using one of the following methods: <br />
            <br />
            <ul>
              <li>click the unsubscribe link on any marketing emails that we send you.</li>
              <li>
                email us at <a href='mailto:support@wtn.zendesk.com'>support@wtn.zendesk.com</a> and
                we’ll be happy to contact you to help change your preferences. (As this isn’t a
                secure channel, please don’t include any personal details in any emails sent to this
                address.)
              </li>
              <li>
                updating your preferences directly in your account (which will be available in
                upcoming release later in 2023).
              </li>
            </ul>
          </p>
          <p>
            You will then be removed from the marketing email list — however, we may still
            communicate with you, for example to send you service-related emails that are necessary
            for the administration and use of your account, to respond to service requests, or for
            other non-marketing purposes.
          </p>
        </>
      ),
    },
    {
      title: 'Who we share your personal data with',
      content: props => (
        <>
          <p>
            Your personal data may be shared with ITF Limited, registered in the Bahamas. Hosting
            and storage of your personal data takes place on the WTN platform which is administered
            by our technology solution provider ClubSpark who are acting as the ITF's data
            processor. All personal data is stored in the UK or European Union but may be accessed
            by organisations based outside of the EU (e.g. NTAs).
          </p>
          <p>
            Your personal data may also be hosted and stored by the ITF on platforms operated by
            Microsoft (Azure and Dynamics 365).
          </p>
          <p>We share your personal data with:</p>
          <ul>
            <li>you and any person you ask us to provide information to;</li>
            <li>your NTA and RTA;</li>
            <li>additional NTAs or RTAs that you have chosen to share data with;</li>
            <li>the NTAs of players you compete against;</li>
            <li>our platform partner, Clubspark;</li>
            <li>
              our service providers including: (i) Microsoft, the suppliers of our mailing and
              customer database systems; (ii) Two Circles and Livewire, our digital support agencies
              and (iii) other service providers that we use to assist us achieve the purposes
              described above.
            </li>
          </ul>
          <p>
            We also publish WTN profiles on www.worldtennisnumber.com. A profile includes your name,
            age (which may be specific or by age banding), country, WTN statistics, playing history,
            and any additional information that you submit. Whether your WTN profile is published
            depends on the route by which you have obtained a WTN (either directly, or through your
            NTA or RTA, or through playing on ITF tours and holding an IPIN). Currently we publish
            your profile in the following situations:
          </p>
          <ul>
            <li>
              Profiles are available to the wider public if:
              <ul>
                <li>
                  you have registered as a user of the website (and not opted-out via the below
                  methods);
                </li>
                <li>you play on an ITF tour; or</li>
                <li>
                  your NTA or RTA has elected to display all their players’ profiles on an opt-out
                  basis, and you have not opted out.
                </li>
              </ul>
            </li>
          </ul>
          <p>
            The way that you can opt-in or opt-out of this publication is being developed (as at
            August 2023). Players on the ITF tour should submit an objection request (as further
            described in section 10 below). All other players can email us at{' '}
            <a href='mailto:support@wtn.zendesk.com'>support@wtn.zendesk.com</a> and we’ll be happy
            change your settings. (As this isn’t a secure channel, please don’t include any personal
            details in any emails sent to this address.) Later in 2023, those other players will
            also be able to change their preferences directly in their account.
          </p>
          <p>
            ClubSpark, Microsoft, Two Circles, and Livewire each acts as a data processor on behalf
            of the ITF which means they will only act on our instructions. Your NTA, RTA, and any
            other third party will be a separate data controller in respect of your personal data,
            and will process your personal data in accordance with the applicable data protection
            laws relevant to that organisation.
          </p>
          <p>
            Personal data may be shared with government authorities, law enforcement officials and
            arbitrators or regulatory disputes that involve you and us, provided that disclosure is
            mandated by law or if required for the legal protection of our legitimate interests in
            compliance with applicable laws.
          </p>
        </>
      ),
    },
    {
      title: 'How long we will hold your data',
      content: props => (
        <>
          <p>
            We will hold information about you only for as long as we need it for the purpose for
            which we collected it, which is as follows:
          </p>
          <ul>
            <li>
              your contact details and player profile information &ndash; for as long as you have a
              WTN and then one year after you cancel your registration and/or de-activate your
              account;
            </li>
            <li>
              your performance results and WTN statistics &ndash; for as long as you have a WTN
              account. After you cancel your registration and/or de-activate your account, we will
              keep your profile within the system to maintain accurate sporting records and to
              ensure the effective delivery of the WTN to other users (in particular those you have
              played against), but we will apply a pseudonym to it so that you are not easily
              identifiable;
            </li>
            <li>
              if you ask us to stop processing your data to send you marketing emails, we will stop
              immediately (but there may be a short period required to allow us to so do and we will
              need to keep limited information to respect your wishes);
            </li>
            <li>
              if you have provided any personal data specifically to enter an ITF promotional
              competition, we will delete that personal data immediately after the competition has
              finished (but if during that entry you consent to receive marketing emails we will
              continue to process your details for that purpose).
            </li>
          </ul>
          <p>
            We may retain the data for longer where it is necessary for us to meet our legal and
            regulatory obligations. For example, personal data linked to disciplinary cases under
            applicable regulations, subject access requests, disputes, or safeguarding
            investigations will be kept for as long as it is necessary for those purposes, as each
            is applicable.
          </p>
        </>
      ),
    },
    {
      title: 'Your legal rights',
      content: props => (
        <>
          <p>You have a number of rights over your personal data processed by us. These include:</p>
          <ul>
            <li>access to, and correction of, incomplete, inaccurate or outdated personal data;</li>
            <li>transmission of personal data to you or to another person or organisation;</li>
            <li>erasure of personal data;</li>
            <li>restriction to our processing of your personal data; and</li>
            <li>objection to processing personal data.</li>
          </ul>
          <p>
            If we receive a request from you to exercise any of the above rights, we may ask you to
            verify your identity before acting on the request; this is to ensure that your data is
            protected and kept secure.
          </p>
          <p>
            The extent of these rights are limited by law and we may not act on part or all of your
            request(s) where the right(s) are not applicable. If we do not act on your request, we
            will explain our reasons why. Please contact us through our Data Protection Officer if
            you require any further information or wish to make a request to exercise any of your
            rights under applicable Data Protection laws. If you wish to make a request to exercise
            your right of transmitting your personal data to you or to another person or
            organisation please contact the helpdesk (
            <a href='mailto:support@wtn.zendesk.com'>support@wtn.zendesk.com</a>). In most cases we
            will respond to your request within one month.
          </p>
        </>
      ),
    },
    {
      title: 'Sending your personal data outside the UK and the EEA',
      content: props => (
        <>
          <p>
            If your NTA or RTA is based outside Europe we have to send your personal data outside
            Europe. If you play a tennis match outside Europe we may send your personal data to the
            NTA of the country or RTA of the region where you play but only if it is necessary for
            your WTN or the NTA or RTA needs it for their records. We only send your personal data
            in a safe and secure way. You can contact us for more information about this.
          </p>
        </>
      ),
    },
    {
      title: 'How to complain',
      content: props => (
        <>
          <p>
            Please contact our Data Protection Officer of EU Representative using the details above
            if you are unhappy with the outcome of any of your requests to exercise your rights, or
            how we handle your personal data.
          </p>
          <p>
            You are also entitled to complain to the Information Commissioner&rsquo;s Office via{' '}
            <a href='http://www.ico.org.uk' target='_blank' rel='noopener noreferrer'>
              www.ico.org.uk
            </a>
            .
          </p>
        </>
      ),
    },
    {
      title: 'Our Privacy Notice available in other formats',
      content: props => (
        <>
          <p>
            We provide our Privacy Notice translated into French and Spanish. We can also provide
            our Privacy Notice in large print, Braille and audio upon request.
          </p>
        </>
      ),
    },
  ],
}
